import { ZomentumRoutes } from "@/Contracts";
import { useRouteMatch } from "react-router-dom";

interface NotForPDFView {
	notForPdfView: (action: () => Promise<void> | void) => Promise<void>;
}

const useNotForPdfView = (): NotForPDFView => {
	const isPdfView = useRouteMatch(ZomentumRoutes.DocumentsPdfView)?.isExact;
	const notForPdfView = async (action: () => Promise<void> | void) => {
		if (isPdfView) {
			return; // do nothing
		}
		await action();
	};
	return {
		notForPdfView
	};
};

export default useNotForPdfView;
